export const newsList = [
  {
    id: "news-001",
    title: "《星际回声》定档国庆，科幻巨制引发全球期待",
    summary:
      "由岑屿执导的科幻电影《星际回声》正式宣布定档，首支预告上线后迅速登上多个平台热搜，海外媒体也给予高度评价。",
    content: [
      "备受关注的科幻电影《星际回声》于今日正式宣布定档，将于本年度国庆档期与观众见面。片方同时发布了首支正式预告与主视觉海报，预告上线仅数小时便登上多个平台的热搜榜单。",
      "影片讲述了人类第一次接收到来自深空的规律信号，并组建国际团队前往回应的故事。导演岑屿在采访中表示，这部电影想探讨的不只是宇宙，更是人类在面对未知时的勇气与孤独。",
      "据片方透露，影片在视觉特效上投入了大量资源，并邀请了多支国际团队参与制作。海外媒体在提前观影后评价其“兼具商业大片的格局与人文关怀的温度”。",
      "随着定档消息公布，相关话题的讨论热度持续攀升，不少影迷表示已将其列入年度必看清单。",
    ],
    date: "2025-09-18",
    source: "星空传媒编辑部",
    category: "电影动态",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20news%20cover%2C%20astronaut%20beside%20a%20giant%20glowing%20blue%20planet%2C%20deep%20blue%20space%20with%20warm%20orange%20edge%20light%2C%20dramatic%20scale%2C%20high%20detail&width=800&height=500&seq=xk-news-001&orientation=landscape",
  },
  {
    id: "news-002",
    title: "《长安夜行》收官在即，古装悬疑再创收视新高",
    summary:
      "热播剧《长安夜行》即将迎来大结局，播出期间收视率持续走高，被观众称为“近年最烧脑的古装悬疑剧”。",
    content: [
      "由顾长风执导的古装悬疑剧《长安夜行》即将迎来收官。该剧自播出以来收视率持续攀升，网络播放量也已突破新的里程碑。",
      "剧集以盛唐长安为背景，讲述司刑少卿沈砚与江湖游侠陆离联手侦破连环奇案的故事。紧凑的节奏与扎实的美术设计，让不少观众直呼“每一帧都值得反复观看”。",
      "有业内人士分析，该剧的成功在于把历史质感与悬疑叙事很好地结合，既保留了古装剧的审美，又满足了当代观众对强情节的需求。",
      "片方表示，大结局将揭晓贯穿全剧的核心悬念，并已为可能的续作埋下伏笔。",
    ],
    date: "2025-09-12",
    source: "剧集观察",
    category: "剧集资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20misty%20rooftops%2C%20cinematic%20period%20drama%20news%20cover%2C%20deep%20indigo%20with%20amber%20glow%2C%20mysterious%20atmosphere%2C%20high%20detail&width=800&height=500&seq=xk-news-002&orientation=landscape",
  },
  {
    id: "news-003",
    title: "《星光舞台》决赛之夜官宣，素人歌手迎来高光时刻",
    summary:
      "音乐竞演综艺《星光舞台》宣布决赛阵容，多位素人歌手凭借真实故事与扎实唱功圈粉无数。",
    content: [
      "音乐竞演综艺《星光舞台》今日公布决赛阵容。经过多轮竞演，多位来自不同行业的素人歌手成功晋级，将在决赛之夜展开最终角逐。",
      "节目自开播以来，凭借“用声音讲故事”的定位收获了良好的口碑。不少参赛者的经历被观众自发分享，相关话题多次登上热搜。",
      "总导演苏原表示，节目最想留住的是普通人与音乐之间最真诚的连接，“舞台会熄灯，但歌声不会”。",
      "据悉，决赛之夜将采用全新赛制，并邀请多位专业音乐人担任现场评审。",
    ],
    date: "2025-09-08",
    source: "文娱前线",
    category: "综艺资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Glowing%20concert%20stage%20with%20spotlights%20and%20confetti%2C%20music%20competition%20show%20news%20cover%2C%20deep%20blue%20with%20warm%20orange%20stage%20lighting%2C%20energetic%20atmosphere%2C%20high%20detail&width=800&height=500&seq=xk-news-003&orientation=landscape",
  },
  {
    id: "news-004",
    title: "《迷雾追凶》登顶年度评分榜，悬疑剧为何越来越“上头”",
    summary:
      "韩剧《迷雾追凶》以高分登顶年度剧集评分榜，悬疑题材的持续走红引发行业讨论。",
    content: [
      "韩剧《迷雾追凶》播出后口碑持续走高，目前已在多个评分平台登顶年度剧集榜。该剧以一桩桩看似无关的失踪案，串联起一个庞大的真相。",
      "业内观察人士指出，悬疑剧的走红并非偶然。紧凑的叙事节奏、可讨论的谜题设计，以及观众在社交平台上的推理互动，共同构成了新的观看体验。",
      "与此同时，悬疑题材也面临同质化的挑战。如何在保持类型优势的同时讲出新意，成为创作者需要持续思考的问题。",
      "《迷雾追凶》主创团队在采访中表示，他们更在意的是人物在极端处境下的选择，而非谜题本身。",
    ],
    date: "2025-09-02",
    source: "影视产业观察",
    category: "行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20city%20alley%20at%20night%20with%20cold%20streetlights%2C%20crime%20thriller%20news%20cover%2C%20dark%20teal%20with%20amber%20accents%2C%20tense%20moody%20atmosphere%2C%20high%20detail&width=800&height=500&seq=xk-news-004&orientation=landscape",
  },
  {
    id: "news-005",
    title: "动画电影《深海之光》重映，治愈系口碑再度发酵",
    summary:
      "日本动画电影《深海之光》宣布重映，许多观众表示愿意再次走进影院，重温那份久违的治愈。",
    content: [
      "由早见悠真执导的动画电影《深海之光》宣布将于近期重映。该片上映时便以细腻的情感与惊艳的画面获得广泛好评。",
      "影片讲述了一位海边小镇的女孩与一只发光深海生物的相遇之旅。简约的故事背后，是对成长与告别的温柔注视。",
      "重映消息公布后，不少观众留言称“当年哭着走出影院，这次还想再去一次”。片方表示，重映版本将对部分画面进行修复升级。",
      "有评论认为，这类作品的长线生命力，说明观众对真诚叙事的期待从未改变。",
    ],
    date: "2025-08-27",
    source: "星空传媒编辑部",
    category: "电影动态",
    cover:
      "https://readdy.ai/api/search-image?query=Glowing%20jellyfish%20in%20a%20deep%20blue%20ocean%2C%20anime%20film%20news%20cover%2C%20magical%20warm%20light%20particles%2C%20dreamlike%20atmosphere%2C%20high%20detail%20illustration&width=800&height=500&seq=xk-news-005&orientation=landscape",
  },
  {
    id: "news-006",
    title: "秋季档片单出炉：现实题材与类型片齐发力",
    summary:
      "多家平台陆续公布秋季档片单，现实题材剧集与高概念类型片同时发力，竞争格外激烈。",
    content: [
      "随着暑期档落幕，各大平台陆续公布了秋季档片单。从已曝光的项目来看，现实题材与类型片的“双线竞争”成为主要看点。",
      "现实题材方面，多部聚焦职场、家庭与代际沟通的剧集蓄势待发；类型片方面，则有多部科幻、悬疑与动作作品排队上线。",
      "分析师指出，档期内容的多元化，反映出平台在用户结构变化下的策略调整。观众的口味越来越细分，对内容的“精准度”要求也更高。",
      "对观众而言，这无疑是一个内容选择格外丰富的季节。",
    ],
    date: "2025-08-20",
    source: "文娱前线",
    category: "行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=Autumn%20season%20entertainment%20lineup%20news%20cover%2C%20stack%20of%20cinema%20tickets%20and%20popcorn%20on%20a%20desk%2C%20warm%20orange%20with%20deep%20blue%20accents%2C%20clean%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=xk-news-006&orientation=landscape",
  },
  {
    id: "news-007",
    title: "《时光信笺》票房破十亿，爱情奇幻题材焕发新生",
    summary:
      "爱情奇幻电影《时光信笺》累计票房突破十亿，成为同类型作品中的一匹黑马。",
    content: [
      "由沈淮执导的电影《时光信笺》上映以来表现强劲，累计票房正式突破十亿大关，成为同类型作品中的一匹黑马。",
      "影片以“一封寄错年代的信”为起点，讲述两个被时间隔开的年轻人之间的故事。上映后，不少观众被其中克制的浪漫打动。",
      "有影评人认为，影片的成功在于把奇幻设定落在真实的情感之上，“它没有炫技，只是认真地讲了一段感情”。",
      "片方透露，关于影片的幕后制作特辑与衍生内容也将陆续与观众见面。",
    ],
    date: "2025-08-14",
    source: "星空传媒编辑部",
    category: "电影动态",
    cover:
      "https://readdy.ai/api/search-image?query=Old%20wooden%20mailbox%20with%20glowing%20letters%20floating%2C%20romantic%20fantasy%20film%20news%20cover%2C%20warm%20golden%20light%20against%20deep%20blue%20evening%2C%20dreamy%20atmosphere%2C%20high%20detail&width=800&height=500&seq=xk-news-007&orientation=landscape",
  },
  {
    id: "news-008",
    title: "综艺市场观察：慢综艺为何依旧“治愈”观众",
    summary:
      "在快节奏内容占据主流的同时，一批慢节奏综艺仍保持稳定热度，成为不少观众的“电子缓释药”。",
    content: [
      "在快节奏、强刺激内容层出不穷的当下，一批主打慢节奏与生活感的综艺依然保持着稳定的热度，《旅行者日记》《美食奇遇记》等作品不断收获新观众。",
      "有研究者指出，慢综艺的价值不在于制造话题，而在于提供一种“被允许放慢”的观看体验。它让观众在疲惫之余，获得情绪上的喘息。",
      "与此同时，慢综艺也在寻找新的表达方式。如何避免同质化、保持真实感，是创作者需要长期面对的问题。",
      "可以预见，在注意力愈发稀缺的时代，这类作品仍会拥有它不可替代的位置。",
    ],
    date: "2025-08-06",
    source: "影视产业观察",
    category: "综艺资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Slow%20living%20variety%20show%20news%20cover%2C%20travelers%20on%20a%20mountain%20train%20overlooking%20misty%20valleys%2C%20deep%20blue%20dawn%20sky%20with%20warm%20sunrise%20glow%2C%20serene%20mood%2C%20high%20detail&width=800&height=500&seq=xk-news-008&orientation=landscape",
  },
];